export const ACCEPT_PATH = ['/', '/guide', '/blog', '/listing', '/about-us', '/404', '/500'];
export const PROTECTED_PATH = ['/my', '/shortlist', '/order', '/reservation', '/carts', '/request-room/form'];
